<script>
import('@/design/css/style.css');
import { authFackMethods } from '@/state/helpers';
import router from '@/router';

export default {
	name: 'Header',
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			isLogin: false,
		};
	},
	mounted() {
		this.checkLoginStatus();
		this.addGtmScript();
	},
	methods: {
		...authFackMethods,
		logOut() {
			this.frontLogout();
		},
		profile() {
			router.push({ name: 'profile' });
		},
		checkLoginStatus() {
			const component = this;
			let json = localStorage.getItem('web_user');
			if (!json) {
				component.isLogin = false;
				return;
			}

			let user = JSON.parse(json);
			if (!user || !Object.hasOwn(user, 'token') || user.token == null) {
				component.isLogin = false;
				return;
			}

			component.isLogin = true;
			return;
		},
		addGtmScript() {
			const script = document.createElement('script');
			script.innerHTML = `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-KLDSZG9S');
      `;
			document.head.appendChild(script);
			let ns = `<noscript><iframe src=https://www.googletagmanager.com/ns.html?id=GTM-KLDSZG9S height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;

			document.body.insertAdjacentHTML('beforeend', ns);
		},
	},
};
</script>

<template>
	<header>
		<div class="container">
			<div class="row mx-0">
				<div class="col-12 col-md-4 col-lg-3 text-center text-md-start mb-3 mb-md-0">
					<a href="/"><img class="logo" src="@/assets/images/Front/logo.png" alt="MnTC" /></a>
				</div>
				<div v-if="isLogin == true" class="col-12 col-md-8 col-lg-9 align-self-center text-center text-md-end mb-3 mb-md-0">
					<a @click="profile" href="javascript:;" class="btn btn-header">Profile</a>
					<a @click="logOut" href="javascript:;" class="btn btn-header">Logout</a>
				</div>
				<div v-else class="col-12 col-md-8 col-lg-9 align-self-center text-center text-md-end mb-3 mb-md-0">
					<router-link tag="a" :to="`/volunteer-system/login`" class="btn btn-header">Sign In</router-link>
				</div>
			</div>
		</div>
	</header>
</template>

<style scoped></style>
